<template>
  <div class="wrp">
    <div class="back">
      <span @click="goback"><i class="el-icon-back"></i>Back</span>
    </div>
    <div class="bgd">
      <div class="con">
        <h1>Create POS Brand</h1>
        <h2><i style="font-style:normal;color:#fff">*</i> POS Brand</h2>
        <div class="inputItem">
          <input type="text" v-model="name" @input="validateComplete" maxlength="50" @change="validateComplete" />
        </div>
        <h2>Does it support Doshii ?</h2>
        <div class="radioItem clear">
          <div class="radio">
            <el-radio v-model="boo" label="1">Yes</el-radio>
          </div>
          <div class="radio">
            <el-radio v-model="boo" label="2">No</el-radio>
          </div>
        </div>
        <div class="btm-btns clear">
          <button class="cancel" @click="goback">Cancel</button>
          <button class="confirm" :class="{'disabled': !isComplete}" :disabled="!isComplete" @click="confirm">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/pos'

export default {
  data () {
    return {
      name: '',
      boo: '1',
      // 是否输入完整
      isComplete: false,
      done: 1
    }
  },
  methods: {
    validateComplete(e, type) {
      var that = this
      if (that.name.replace(/\s+/g,'') !== '') {
        that.isComplete = true
      } else {
        that.isComplete = false
      }
    },
    confirm () {
      this.$box.loadings()
      api.addPos({
        params: {
            posBrand: this.name,
            posIsSupport: this.boo === '1' ? 1 : 0
        }, 
        callback: this.addCallback
      })
    },
    addCallback(res) {
      var that = this
      that.$box.loadings(2)
      if(res.data.code == 0){
        that.done = 0
        that.$router.replace('/poslist')
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    goback () {
        this.$router.replace('/poslist')
        this.done = 1
    }
  },
  beforeRouteLeave(to, from, next){
    if(this.done === 0){
      to.meta.isUseCache = false
    } else {
      to.meta.isUseCache = true
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .back{
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-bottom: 56px;
    font-family: 'SFProText-Semibold';
    background: #212429;
    width: 100%;
    z-index: 4;
    height: 20px;
    span{
      display: inline-block;
      width: 100px;
      cursor: pointer;
      i{
        margin-right: 10px;
      }
    }
  }
  .bgd{
    width: 100%;
    background: #2B3444;
    padding: 50px 0 65px 0;
    margin-bottom: 50px;
    .con{
      width: 740px;
      margin: 0 auto;
      .btm-btns{
        width: 610px;
        margin: 65px auto 0 auto;
        button{
          width: 280px;
          height: 60px;
          background: #2B3444;
          float: left;
          box-sizing: border-box;        
          font-size: 26px;
          cursor: pointer;
        }
        .cancel{
          margin-right: 50px;
          border: 2px solid #FFFFFF;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #fff;
        }
        .confirm{
          border: 2px solid #EA3796;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #EA3796;
        }
        .disabled{
          border: 2px solid #8E3771;
          color: #8E3771;
          cursor: not-allowed;
        }
      }
      h1{
        font-family: 'PingFangSC-Semibold';
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h2{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .inputItem{
        width: 100%;
        margin-bottom: 30px;
        position: relative;
        input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
          height: 50px;
        }
        .lft{
          position: absolute;
          left: 20px;
          line-height: 50px;
          color: #fff;
        }
        .rgt{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: #fff;
        }
      }
      .radioItem{
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 41px;
        .radio{
          width: 355px;
          float: left;
          position: relative;
        }
        input{
          width: 318px;
          height: 50px;
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
        }
        .radio:nth-child(1){
          margin-right: 30px;
          input{
            padding: 0 40px 0 15px;
          }
        }
        .radio:nth-child(2){
          input{
            padding: 0 15px 0 40px;
          }
        }
        .percentage{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: #fff;
        }
        .dollar{
          position: absolute;
          left: 56px;
          line-height: 50px;
          color: #fff;
        }
      }
      .dateItem{
        margin-bottom: 30px;
        position:relative;border-radius: 0;
        border: 1px solid #5f5f5f;
        background-color: #151C27;
        height: 50px;
        color: #fff;
        font-family: 'SFProText-Regular';
        font-size: 20px;
        color: #151c27;
        background-size: 23px 22px;
        background-position: 16px center;
        background-repeat: no-repeat;
        background-image: url('../../assets/c.png');
      }
      .btns{
        width: 100%;
        box-sizing: border-box;
        padding-left: 16px;
        div{
          float: left;
          line-height: 60px;
          cursor: pointer;
        }
        .add{
          margin-right: 32px;
        }
        .reset{
          color: #EA3796;
        }
      }
      .timlst{
        width: 100%;
        span{
          display: block;
          float: left;
          line-height: 25px; 
          i{
            font-style: normal;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pos/add.vue